import { config as SanitizeConfig } from '../sanitizers/SanitizeConfiguration';

const getHref = (node: Element) => {
  if ('href' in node && typeof node.href === 'string') {
    return node.href;
  }

  const rawHref = node.getAttribute('href') || '';
  try {
    return new URL(rawHref).href;
  } catch (e) {
    return rawHref;
  }
};

export const addLinkTargetAttribute = ({
  node,
  config,
}: {
  node: Element;
  config: typeof SanitizeConfig;
}) => {
  if (!node || node.tagName.toUpperCase() !== 'A') {
    return null;
  }

  const href = getHref(node);
  if (!href) {
    return null;
  }

  // https://issues.hubspotcentral.com/browse/MESSAGES-2862
  const shouldOpenLinkInSameTab = href.match('(tel|mms|sms|mailto):[0-9]+');

  //https://issues.hubspotcentral.com/browse/MESSAGES-5813
  if (node.getAttribute('target') === '_self' && !shouldOpenLinkInSameTab) {
    node.setAttribute('target', '_top');
  }

  const targetValue = shouldOpenLinkInSameTab
    ? '_self'
    : node.getAttribute('target');

  if (targetValue) {
    node.setAttribute('target', targetValue);
  }

  return { node, config };
};
